import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { toDraft, fromDraft } from "@/lib/fieldCodec";
import { TypeSelect, ValueInput } from "./ValueInput";

export function AddField({ existing, onAdd }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [type, setType] = useState("string");
  const [draft, setDraft] = useState("");

  const reset = () => { setOpen(false); setName(""); setType("string"); setDraft(""); };
  const submit = async () => {
    const key = name.trim();
    if (!key) return toast.error("Field name required");
    if (existing.includes(key)) return toast.error(`"${key}" already exists — edit it instead`);
    let val;
    try { val = fromDraft(draft, type); } catch (e) { return toast.error(e.message); }
    if (await onAdd(key, val)) reset();
  };

  if (!open) return <Button size="sm" variant="outline" className="h-8 gap-1" onClick={() => setOpen(true)} data-testid="add-field-btn"><Icons.Plus className="h-3.5 w-3.5" /> Add field</Button>;
  return (
    <div className="rounded-lg border border-primary/30 bg-primary/5 p-3 space-y-2 w-full" data-testid="add-field-form">
      <div className="flex gap-2">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="field_name" className="h-8 font-mono text-sm" data-testid="add-field-name" />
        <TypeSelect value={type} onChange={(t) => { setType(t); setDraft(toDraft(undefined, t)); }} testId="add-field-type" />
      </div>
      <ValueInput type={type} draft={draft} setDraft={setDraft} testId="add-field-value" />
      <div className="flex gap-2">
        <Button size="sm" className="h-7" onClick={submit} data-testid="add-field-submit">Add</Button>
        <Button size="sm" variant="ghost" className="h-7" onClick={reset} data-testid="add-field-cancel">Cancel</Button>
      </div>
    </div>
  );
}
